import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

import { type Component } from 'vue';
import { SolrFacet } from '../../modules/solr'; // eslint-disable-line import/no-relative-parent-imports
import FacetOptionsMulti from './FacetOptionsMulti.vue';
import FacetOptionsSingle from './FacetOptionsSingle.vue';
import FacetOptionsSingleHierarchy from './FacetOptionsSingleHierarchy.vue';
import FacetOptionsSingleDropdown from './FacetOptionsSingleDropdown.vue';
import FacetOptionsWrapper from './FacetOptionsWrapper.vue';
import FacetOptionsCheckbox from './FacetOptionsCheckbox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetsContainer',
  props: {
    facets: {}
  },
  emits: ["change", "changeMultiple"],
  setup(__props: any, { emit }) {

const props = __props;

const renderTypeComponentMapping: Record<string, Component> = {
    Options: FacetOptionsMulti,
    OptionsSingleMode: FacetOptionsSingle,
    OptionsSingleModeDropdown: FacetOptionsSingleDropdown,
    OptionsSingleHierarchy: FacetOptionsSingleHierarchy,
    OptionsOrMultiDropdown: FacetOptionsWrapper,
    OptionsCheckbox: FacetOptionsCheckbox
};





function change (name: string, value: string, type: ''): void {
    emit('change', name, value, type);
}

function changeMultiple (name: string, value: string[]): void {
    emit('changeMultiple', name, value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.facets.filter(item => item), (facet) => {
    return (_openBlock(), _createBlock(_resolveDynamicComponent(renderTypeComponentMapping[facet.renderType]), {
      key: facet.name,
      facet: facet,
      onChange: change,
      onChangeMultiple: changeMultiple
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, ["facet"]))
  }), 128 /* KEYED_FRAGMENT */))
}
}

})